module.exports = __webpack_public_path__ + "static/media/19ESCAP44.fe0521f6.jpg";